import React, { useEffect, useRef } from 'react';

import Tooltip from 'CommonComponents/Tooltip';

/**
 * `checkedClassName` is the track's checked colour, as a full `peer-checked:` class.
 *
 * A disabled toggle fades its track and label and shows a not-allowed cursor,
 * whether it is on or off.
 */
export default function ToggleInput({ label, indeterminate, tooltip, noBottomSpacing, checkedClassName = 'peer-checked:tw-bg-blue', ...props }) {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = !!indeterminate;
        }
    }, [indeterminate]);

    const toggle = (
        <label className={`inbud-toggle ${noBottomSpacing ? 'tw-mb-0' : 'tw-mb-2'} ${props.disabled ? '!tw-cursor-not-allowed' : ''}`}>
            <input ref={inputRef} type="checkbox" className="input tw-peer" {...props} />
            <div className={`switch tw-peer ${checkedClassName} peer-checked:after:tw-left-[23px] peer-disabled:tw-opacity-50`}></div>
            <span className="label peer-disabled:tw-opacity-50">{label}</span>
        </label>
    );

    if (tooltip) {
        return (
            <Tooltip tooltipType="text" tooltipContent={tooltip}>
                {toggle}
            </Tooltip>
        );
    }

    return toggle;
}
